// extracted by mini-css-extract-plugin
export default {"buttonsContainer":"user-user-groups-list_buttonsContainer__N9w43","list":"user-user-groups-list_list__e2BUp","titleCell":"user-user-groups-list_titleCell__2EcSO"};